import { Controller } from '@hotwired/stimulus';
import { createFocusTrap } from 'focus-trap';
import { useMatchMedia } from 'stimulus-use';

import mediaQueries from '../../utils/media-queries';
import { transition } from '../../utils/transition';

export default class extends Controller {
    static targets = [
        'menuItems',
        'menuOpener',
    ];

    static outlets = ['header--navigation'];

    static values = {
        currentMenuLevel: Number,
        menuOpen: Boolean,
    };

    #trap = null;

    connect() {
        this.isMobileView = false;

        useMatchMedia(this, { mediaQueries: mediaQueries['2xl'] });
    }

    async menuOpenValueChanged() {
        if (!this.isMobileView) {
            return;
        }

        this.menuOpenerTarget.ariaExpanded = this.menuOpenValue;

        if (this.hasMenuItemsTarget) {
            await transition(this.menuItemsTarget, this.menuOpenValue);
        }

        if (this.menuOpenValue) {
            this.#trap = createFocusTrap(this.element, {
                allowOutsideClick: true,
                initialFocus: () => this.headerNavigationOutletElement.querySelector('button'),
            });

            this.#trap.activate();
        } else {
            this.#trap?.deactivate();
            this.#trap = null;
        }

        this.dispatch('toggle', { detail: { open: this.menuOpenValue } });
    }

    isMobile() {
        this.isMobileView = true;

        this.element.querySelector('[role="menubar"]').ariaOrientation = 'vertical';
    }

    notMobile() {
        this.isMobileView = false;

        this.element.querySelector('[role="menubar"]').ariaOrientation = 'horizontal';
    }

    closeNestedMenus() {
        this.headerNavigationOutlets.forEach((outlet) => {
            outlet.closeNestedMenus(this.currentMenuLevelValue);
        });
    }

    toggleMenu() {
        this.menuOpenValue = !this.menuOpenValue;

        this.currentMenuLevelValue = 0;

        if (!this.menuOpenValue) {
            this.closeNestedMenus();
        }
    }

    hide() {
        this.currentMenuLevelValue = 0;
        this.closeNestedMenus();

        this.menuOpenValue = false;
    }

    navigationToggled(event) {
        if (event.detail.open) {
            this.currentMenuLevelValue = Math.max(event.detail.menuLevel, 0);
        } else {
            this.currentMenuLevelValue = Math.max(event.detail.menuLevel - 1, 0);
        }
    }

    back() {
        this.closeNestedMenus();
        this.currentMenuLevelValue = Math.max(this.currentMenuLevelValue - 1, 0);
    }
}
